import { render, staticRenderFns } from "./ReservaCartaoMenu.vue?vue&type=template&id=3eff5abb&scoped=true&"
import script from "./ReservaCartaoMenu.vue?vue&type=script&lang=js&"
export * from "./ReservaCartaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReservaCartaoMenu.vue?vue&type=style&index=0&id=3eff5abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eff5abb",
  null
  
)

export default component.exports